module.exports = __webpack_public_path__ + "img/registrationFee.78239750.svg";